

import { Injectable } from '@angular/core';

import { BehaviorSubject, catchError, map, Observable, of, switchMap, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { env, python } from 'src/environments/environments';
import { AlertService } from 'src/app/services/alerts.service';
import { checkUserActivatedResponseData, CiudUserAuthData, LoginDataService, userDataGoogle } from 'src/app/core/auth/authData.model';
import { CookieService } from 'ngx-cookie-service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  //PROPIEDADES DEl SERVICIO  ===============================
/*   private readonly apiWeb2: string = `${env.url_base}${env.api}${env.landing}${env.perfil_usuario}${env.module.api_perfilUser_end}`;
 */
  private readonly apiWeb3: string = `${python.url_base}`;
  private ciudUserSubject = new BehaviorSubject<CiudUserAuthData | null>(null);
  public ciudUser$: Observable<CiudUserAuthData | null> = this.ciudUserSubject.asObservable();

  private sessionCheckInterval: any;


constructor(
  private http: HttpClient,
  private router: Router,
  private loginDataService: LoginDataService,
  private alertService: AlertService,
  private cookieService: CookieService
) {
  // Cargar usuario inmediatamente si existe
  if (this.isLoggedIn()) {
    const storedUser = sessionStorage.getItem('user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        if (this.isValidUserData(user)) {
          this.ciudUserSubject.next(user);
          this.startSessionCheck();
        }
      } catch (error) {
        console.error('Error parsing stored user:', error);
      }
    }
  }

  // Retrasar initializeSession para evitar sobrescribir
  setTimeout(() => {
    this.initializeSession();
  }, 50);
}
  //METODOS DE VIDA DEl SERVICIO  ===============================


  //METODOS DEL SERVICIO ===============================
  checkUserActivated(email: string): Observable<checkUserActivatedResponseData> {
    const body = {
      email
    };

    return this.http.post<checkUserActivatedResponseData>(`${this.apiWeb3}/checkUuserActivated`, body, { withCredentials: true }).pipe(
      map(response => {
        try {
          if (response.success) {
            return { success: true, message: 'Usuario activado', data: response.data };
          } else {
            return { success: false, message: response.message || 'El usuario no está activado' };
          }
        } catch (error) {
          console.error(error);
          return { success: false, message: 'Hubo un error, por favor, intentelo de nuevo' };
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error en la solicitud:', error);
        return of({ success: false, message: 'Error en la solicitud' });
      })
    );
  }



  login2Web(email: string, password: string, fullDomain: string, recaptchaToken: string, secretKey: string): Observable<{ success: number, message: string, data?: CiudUserAuthData, token_access?: string, refresh_token?: string, is_temp_password?: boolean }> {
    const body = {
      email,
      password,
      fullDomain,
      recaptchaToken,
      secretKey
    };

    return this.http.post<{ success: number, message: string, data?: CiudUserAuthData, token_access?: string, refresh_token?: string, is_temp_password?: boolean }>(`${this.apiWeb3}/login`, body, { withCredentials: true }).pipe(
      map(response => {
        try {
          if(response.success === 1 && response.data){
            const userData = new CiudUserAuthData(response.data );
            const userWithAdditionalData = {
              ...userData,
              logGoogle: false,
              is_temp_password: response.is_temp_password
            };
            sessionStorage.setItem('user', JSON.stringify(userWithAdditionalData));

            this.loginDataService.setData(userData);
            this.ciudUserSubject.next(userData);

            const token_access = response.token_access;
            if (token_access) {
              this.setSessionFromJWT(token_access);
            }

            this.startSessionCheck();

            return { success: 1, message: 'Inicio de sesión exitoso', data: userData };
          } else if (response.success === 2) {
            return { success: 2, message: response.message || 'Credenciales pendientes de completar el proceso de registro. Por favor solicite un nuevo correo con contraseña temporal para finalizar su registro.'};
          } else if (response.success === 3) {
            return { success: 3, message: response.message || 'Contraseña incorrecta, por favor verifica tu correo para continuar con el registro desde el link enviado.'};
          } else{
            return { success: 0, message: response.message || 'El inicio de sesión no fue exitoso. Por favor, intente más tarde.'};
          }
        } catch (error) {
          console.error(error);
          return { success: 0, message: 'Hubo un error, por favor, intentelo de nuevo' };
        }
      }),
      catchError(error => throwError(() => error))
    );
  }


  loginOAuthGoogle(ladata: userDataGoogle, domain: string): Observable<{ success: number, message: string, data?: CiudUserAuthData, token_access?: string, refresh_token?: string, is_temp_password?: boolean }> {
    const body = {
      email: ladata.email,
      email_verified: ladata.email_verified,
      given_name: ladata.given_name,
      family_name: ladata.family_name,
      domain: domain,
    };

    return this.http.post<{ success: number, message: string, data?: CiudUserAuthData, token_access?: string, refresh_token?: string, is_temp_password?: boolean }>(`${this.apiWeb3}/login_registerGoogle`, body, { withCredentials: true }).pipe(
      map(response => {
        try {
          if(response.success === 1 && response.data) {

            const userData = new CiudUserAuthData(response.data );
            const userWithAdditionalData = {
              ...userData,
              logGoogle: true
            };
            sessionStorage.setItem('user', JSON.stringify(userWithAdditionalData));

            this.loginDataService.setData(userData);
            this.ciudUserSubject.next(userData);


            const token_access = response.token_access;
            if (token_access) {
              this.setSessionFromJWT(token_access);
            }

            this.startSessionCheck();

            return { success: 1, message: 'Inicio de sesión exitoso con Google', data: response.data };
          } else{
            return { success: 0, message: 'El inicio de sesión con Google no fue exitoso. Por favor, intente más tarde.' };
          }
        } catch (error) {
          console.error(error);
          return { success: 0, message: 'Hubo un error, por favor, intentelo de nuevo' };
        }
      }),
      catchError(error => throwError(() => error)),
    );
  }



  refreshAccessToken(): Observable<{ success: boolean; token_access?: string, respRefreshData?: {UserData?: CiudUserAuthData, success: boolean} }> {
    const domain = sessionStorage.getItem('domain') || '';

    const body = {
      domain
    };

    return this.http.post<{ success: boolean; token_access?: string, respRefreshData?: {UserData?: CiudUserAuthData, success: boolean} }>(
      `${this.apiWeb3}/refresh_token`,
      body,
      { withCredentials: true }
    ).pipe(
      map(response => {
        if (response.token_access) {
          this.setSessionFromJWT(response.token_access);

          return { success: true, message: 'Token de acceso renovado exitosamente' };
        }
        this.clearInvalidSession();
        return { success: false, message: 'Error al renovar el token' };
      }),
      catchError(error => of({ success: false, message: error.message }))
    );
  }


  performProtectedRequest<T>(
    requestFn: () => Observable<T>
  ): Observable<T> {
    return requestFn().pipe(
      catchError((error) => {
        if (error.status === 401) {
          console.warn('401 Unauthorized. Intentando renovar el token...');
          return this.refreshAccessToken().pipe(
            switchMap((response) => {
              if (response.success) {
                console.log('Token renovado. Reintentando la solicitud...');
                return requestFn();
              } else {
                console.error('No se pudo renovar el token. Redirigiendo al login...');
                this.logout();
                this.router.navigate(['/iniciar-sesion']);
                return throwError(() => new Error('No autorizado'));
              }
            })
          );
        }
        return throwError(() => error);
      })
    );
  }


  //METODOS COMUNES PARA EL SERVICIO ===============================
  private initializeSession(): void {
  this.refreshAccessToken().subscribe({
    next: (response) => {
      if (response.success) {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
          try {
            const user = JSON.parse(storedUser);
            if (this.isValidUserData(user)) {
              this.ciudUserSubject.next(user);
            } else {
              console.warn('Datos de usuario inválidos en sessionStorage');
              this.clearInvalidSession();
            }
          } catch (error) {
            console.error('Error parsing stored user:', error);
            this.clearInvalidSession();
          }
        } else if (response?.respRefreshData?.UserData) {
          if (this.isValidServerUserData(response.respRefreshData.UserData)) {
            const userData = new CiudUserAuthData(response.respRefreshData.UserData);
            this.loginDataService.setData(userData);
            this.ciudUserSubject.next(userData);
            sessionStorage.setItem('user', JSON.stringify(userData));
            this.router.navigate(['/inicio']);
          } else {
            console.warn('Datos de usuario inválidos del servidor');
            this.clearInvalidSession();
          }
        } else {
          console.warn('No hay datos de usuario disponibles');
          this.clearInvalidSession();
        }
      } else {
        console.warn('No se pudo restaurar la sesión automáticamente');
        this.clearInvalidSession();
      }
    },
    error: (err) => {
      console.error('Error al restaurar la sesión:', err);
      this.clearInvalidSession();
    }
  });
}

private isValidUserData(userData: any): boolean {
  return userData &&
         typeof userData === 'object' &&
         userData.id_ciud &&
         userData.email &&
         userData.primer_nombre;
}

private isValidServerUserData(userData: any): boolean {
  return userData &&
         typeof userData === 'object' &&
         (userData.id_ciud || userData.id) && // El servidor podría enviar 'id' en lugar de 'id_ciud'
         userData.email;
}

  restoreSessionFromCookies(): Observable<boolean> {
    return this.refreshAccessToken().pipe(
      map((response) => {
        if (response.success && response?.respRefreshData?.UserData) {
          const userData = new CiudUserAuthData(response.respRefreshData.UserData);

          // Guardamos datos de usuario y actualizamos el estado
          const userWithAdditionalData = {
            ...userData,
            logGoogle: false // Asumimos login normal por defecto
          };

          sessionStorage.setItem('user', JSON.stringify(userWithAdditionalData));
          this.ciudUserSubject.next(userData);
          this.loginDataService.setData(userData);

          // Iniciar chequeo periódico de sesión
          this.startSessionCheck();

          return true;
        } else {
          this.clearInvalidSession();
          return false;
        }
      }),
      catchError(() => {
        this.clearInvalidSession();
        return of(false);
      })
    );
  }


  private clearInvalidSession(): void {
    this.stopSessionCheck();
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('loginTime');
    this.ciudUserSubject.next(null);
  }

  // Método para establecer la sesión a partir de un JWT
  private setSessionFromJWT(jwt: string) {
    const decodedToken = this.decodeJWT(jwt);
    if (decodedToken) {
      const expirationTime = decodedToken.exp * 1000;
      sessionStorage.setItem('loginTime', JSON.stringify({ loginTime: new Date().getTime(), expirationTime }));
    }
  }


  private decodeJWT(token: string) {
    try {
      const payload = token.split('.')[1];
      return JSON.parse(atob(payload));
    } catch (e) {
      return null;
    }
  }

  // Método para iniciar el intervalo de verificación de sesión
  startSessionCheck() {
    console.warn('Iniciando verificación de sesión...');
    this.stopSessionCheck();
    this.sessionCheckInterval = setInterval(() => {
      console.warn('Verificando sesión...' + '\n');
      if (!this.isLoggedIn()) {
        console.warn(' sesión verificada... No esta logueado' + '\n');
          this.logout();
      } else {
        console.warn('Sigue logueado' + '\n');
      }
    }, 60000);
  }

  stopSessionCheck() {
    if (this.sessionCheckInterval) {
      clearInterval(this.sessionCheckInterval);
      this.sessionCheckInterval = null;
    }
  }

  isLoggedIn(): boolean {
    const userExists = !!sessionStorage.getItem('user');
    if (!userExists) {
      return false;
    }

    // Verificar si las cookies 'token' y 'refresh_token' existen
    const hasToken = this.checkCookieExists('token');
    const hasRefreshToken = this.checkCookieExists('refresh_token');

    if (!hasToken) {
      if (hasRefreshToken) {
        console.warn('Token de accesso no encontrado, refrescando token');
        this.refreshAccessToken().subscribe({
          next: (response) => {
            if (response.success) {
              console.log('Token de acceso renovado exitosamente');
            } else {
              console.warn('No se pudo renovar el token de acceso');
              this.logout();
            }
          },
          error: (err) => {
            console.error('Error al renovar el token de acceso:', err);
            this.logout();
          },
        });
      } else {
        console.warn('Tokens de acceso no encontrados');
        return false;
      }
    }

    // Verificar si el token sigue siendo válido
    const loginTime = JSON.parse(sessionStorage.getItem('loginTime') || '{}');
    const currentTime = new Date().getTime();

    if (loginTime && currentTime > loginTime.expirationTime) {
      this.logout(); // Si el token ha expirado, cerrar sesión
      console.warn('Token expirado, pero NO se redirecciona automáticamente');

      return false;
    }

    return true;
  }



  logout() {
    //this.router.navigate(['/inicio']);
    const domain = sessionStorage.getItem('domain') || '';
    const body = { domain };

    // Primero limpiar los datos locales
    this.stopSessionCheck();
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('loginTime');
    this.ciudUserSubject.next(null);

    // Limpiar cookies manualmente como respaldo
    this.cookieService.delete('token', '/');
    this.cookieService.delete('refresh_token', '/');

    if (domain.includes('ayudacatastro')) {
      this.cookieService.delete('token', '/', '.ayudacatastro.co');
      this.cookieService.delete('refresh_token', '/', '.ayudacatastro.co');
    }

    this.http.post(`${this.apiWeb3}/logout`, body, { withCredentials: true }).subscribe({
      next: () => {
        window.location.reload();
        this.alertService.showAlert('Se ha cerrado sesión.', 'info');
      },
      error: (err) => {
        console.error('Error al cerrar sesión:', err);
        setTimeout(() => {
          this.router.navigate(['/iniciar-sesion']);
          window.location.reload();
        }, 300);
      },
    });
  }


  getCurrentUser(): CiudUserAuthData | null {
    return this.ciudUserSubject.value;
  }

  updateUserProfile(userData: CiudUserAuthData) {
    this.ciudUserSubject.next(userData);
    sessionStorage.setItem('user', JSON.stringify(userData));
  }

  checkCookieExists(cookieName: string): boolean {
    const cookie = this.cookieService.get(cookieName);
    return !!cookie;  // Retorna true si la cookie existe, de lo contrario false
  }
}
